﻿'use strict'

import { tns } from 'tiny-slider/src/tiny-slider'

const carousel = {
    init: function () {
        let wrapper = document.querySelectorAll("[carousel-wrapper]");
        
        for (let i = 0; i < wrapper.length; i++) {
            let container = wrapper[i].querySelector("[carousel]");
            let navContainer = wrapper[i].querySelector("[carousel-nav]");
            let prevButton = wrapper[i].querySelector("[carousel-prev]");
            let nextButton = wrapper[i].querySelector("[carousel-next]");


            var slider = tns({
                loop: false,
                container: container,
                items: 1,
                controls: true,
                mode: "carousel",
                navContainer: navContainer,
                prevButton: prevButton,
                nextButton: nextButton,
            });
        }
    }
}

export default carousel.init();

